import React, { Component } from 'react';
import Moment from 'react-moment';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import GetAuthorName from './GetAuthorName';
import Share from './Share';

export default class Single extends Component {
    getBlogHeader() {
        if (this.props.featuredImage) {
            return (
                <div>
                    <header id="detail-header" className="header-cover">
                        <div className="cover-wrapper">
                            <div className="cover-img">
                                <img
                                    src={
                                        this.props.featuredImage.large
                                            .source_url
                                    }
                                    alt={`cover ${this.props.title}`}
                                    srcSet={`${this.props.featuredImage.large.source_url} 683w, ${this.props.featuredImage.img_square_big.source_url} 667w`}
                                    sizes={`(min-width:667px) 683px, 100vw`}
                                />
                            </div>
                            <div className="entry-title image-bg">
                                {this.props.type === 'post' ? (
                                    <h3 className="date">
                                        <Moment format="DD.MM.YYYY">
                                            {this.props.date}
                                        </Moment>
                                    </h3>
                                ) : (
                                    ''
                                )}
                                <h1>{this.props.title}</h1>
                            </div>
                        </div>
                    </header>
                    {this.props.type === 'post' ? (
                        <div className="post-meta">
                            <GetAuthorName
                                url={this.props.links.author[0].href}
                            />
                            <Share
                                title={this.props.title}
                                type={this.props.type}
                            />
                        </div>
                    ) : (
                        ''
                    )}
                </div>
            );
        } else {
            // Als er geen afbeelding is.
            return (
                <div>
                    <header id="detail-header" className="header-nocover">
                        <div className="entry-title">
                            {this.props.type === 'post' ? (
                                <h3 className="date">
                                    <Moment format="DD.MM.YYYY">
                                        {this.props.date}
                                    </Moment>
                                </h3>
                            ) : (
                                ''
                            )}
                            <h1>{this.props.title}</h1>
                        </div>
                    </header>
                    {this.props.type === 'post' ? (
                        <div className="post-meta">
                            <GetAuthorName
                                url={this.props.links.author[0].href}
                            />
                            <Share
                                title={this.props.title}
                                type={this.props.type}
                            />
                        </div>
                    ) : (
                        ''
                    )}
                </div>
            );
        }
    }

    render() {
        return (
            <div className={`inner-container`}>
                {this.props.type === 'work' ? (
                    ''
                ) : (
                    <div className="header-blog">{this.getBlogHeader()}</div>
                )}
                <div className="clearfix" />
                <div
                    className="entry-content"
                    dangerouslySetInnerHTML={{ __html: this.props.content }}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Single.jsx